import { Fa6 } from "react-icons/fa6";

interface IconBtnProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  Icon: typeof Fa6;
  selected?: boolean;
}

const IconBtn: React.FC<IconBtnProps> = ({ Icon, selected, ...props }) => {

  return (
    <button
      className={`flex justify-center items-center w-[48px] h-[48px] cursor-pointer ${
        selected 
        ? "bg-primary-blue-500 dark:bg-primary-blue-400"
        : "bg-neutral-gray-5 dark:bg-neutral-gray-800"
      } rounded-[8px] p-1 duration-300 ease-in-out`}
      {...props}
    >
      {Icon && (
        <Icon
          className={`${
            selected ? "fill-neutral-gray-5" : "fill-neutral-gray-600 dark:fill-neutral-gray-600"
          }`}
        />
      )}
    </button>
  );
};

export default IconBtn;